import useTranslate from "@pathwright/ux/src/components/lng/useTranslate"
import Tip, { TipProps } from "../../tips/Tip"

function HomeLibraryBlankSlateTip(props: Partial<TipProps>) {
  const { t } = useTranslate()
  return (
    <Tip
      tip={{
        title: t("user_library.blank_slate.title", "Your Library"),
        content: t(
          "user_library.blank_slate.content",
          "Your Library is where you can keep track of paths you’ve Set Aside for later."
        )
      }}
      icon="lightbulb-on"
      layout="default"
      colorPalette="dark"
      {...props}
    />
  )
}

export default HomeLibraryBlankSlateTip
